<div>
    <div
        *ngIf="this.magocloudService.currentIndustry?.IndustryEditions"
        fxlayout="row wrap"
        class="price-tables"
        style="flex-flow: row wrap; box-sizing: border-box; display: flex; place-content: center; align-items: left"
    >
        <div
            fxlayout="column"
            [ngClass]="
                this.magocloudService.edition == edition.EditionCode
                    ? 'price-table price-table-selected style-3 mat-elevation-z15 '
                    : 'price-table style-3 mat-elevation-z4'
            "
            style="flex-direction: column; box-sizing: border-box; display: flex"
            *ngFor="let edition of this.magocloudService.currentIndustry?.IndustryEditions"
        >
            <div class="package-type">
                <div><img [src]="'./assets/images/icon_' + edition.EditionCode + '.png'" alt=" " /></div>
                <div class="title">{{ edition.EditionDescription }}</div>
                <div class="subtitle">{{ getCorrectDescription(edition.EditionCode) }}</div>
            </div>
            <div>
                <div
                    fxlayout="row"
                    fxlayoutalign="center start"
                    style="
                        flex-direction: row;
                        box-sizing: border-box;
                        display: flex;
                        place-content: flex-start center;
                        align-items: flex-start;
                    "
                >
                    <div
                        fxlayout="row"
                        fxlayoutalign="center end"
                        style="
                            flex-direction: row;
                            box-sizing: border-box;
                            display: flex;
                            place-content: flex-end center;
                            align-items: flex-end;
                        "
                    ></div>
                </div>
            </div>
            <div
                fxlayout="column "
                fxlayoutalign="start center "
                style="flex-direction: column; box-sizing: border-box; display: flex; place-content: center flex-start; align-items: center"
            >
                <button mat-flat-button color="primary" class="buttonEditionChoice" (click)="onClickEdition(edition.EditionCode)">
                    <span translate>INDUSTRY_CONFIGURATOR.SELECT</span>
                </button>
            </div>
        </div>
    </div>
</div>
